import { render, staticRenderFns } from "./BookingItems.vue?vue&type=template&id=67aae8a0"
import script from "./BookingItems.vue?vue&type=script&lang=js"
export * from "./BookingItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports